import { ErrorPage, ErrorPageType } from '@exam-management/components';
import { QBankStructureStatus } from '@exam-management/graphql';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QBANK_STRUCTURE_LEVEL_ITEM_FORM_ACTION_QUERY_KEY,
  QBankStructureLevelItemFormAction,
} from '@exam-management/qbank-structure-detail';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { PermissionGuard } from '@shared/permissions';
import { Outlet, useSearchParams } from 'react-router-dom';

export default function QBankStructureDetailsLayout() {
  const [searchParams] = useSearchParams();
  const {
    qBankStructureInformation: { status },
    pageAccessibility,
  } = useQBankStructure();

  const isAllowEdit = [QBankStructureStatus.Draft, QBankStructureStatus.Unpublished].includes(
    status,
  );

  const action = isAllowEdit
    ? ((searchParams.get(QBANK_STRUCTURE_LEVEL_ITEM_FORM_ACTION_QUERY_KEY) ??
        QBankStructureLevelItemFormAction.VIEW) as QBankStructureLevelItemFormAction)
    : QBankStructureLevelItemFormAction.VIEW;

  if (!pageAccessibility.structure) {
    return <ErrorPage errorType={ErrorPageType.NO_PERMISSION} />;
  }

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QBANK.STRUCTURE.VIEW}>
      <Outlet context={{ action }} />
    </PermissionGuard>
  );
}
